import React from 'react';
import {
  Box,
  Container,
  Button,
  Typography,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { CancelOutlined, Login, Home, EventNote } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContextNew';

const OfflinePaymentCancel = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #4a3728 0%, #2d2218 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={24}
          sx={{
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            textAlign: 'center'
          }}
        >
          <Box
            sx={{
              width: 88,
              height: 88,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #bf360c 0%, #8d2f0a 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2
            }}
          >
            <CancelOutlined sx={{ fontSize: 52, color: 'white' }} />
          </Box>
          <Typography variant={isMobile ? 'h5' : 'h4'} component="h1" gutterBottom fontWeight={700}>
            Payment not completed
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            You cancelled checkout or closed the payment window. No charge was made. You can try again from the link you received, or sign in to pay from your account.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 2 }}>
            {isAuthenticated && (
              <Button
                variant="contained"
                size="large"
                startIcon={<EventNote />}
                onClick={() => navigate('/bookings')}
                fullWidth
              >
                My bookings
              </Button>
            )}
            {!isAuthenticated && (
              <Button
                variant="contained"
                size="large"
                startIcon={<Login />}
                onClick={() => navigate('/login')}
                fullWidth
              >
                Sign in
              </Button>
            )}
            <Button
              variant="outlined"
              size="large"
              startIcon={<Home />}
              onClick={() => navigate('/guest')}
              fullWidth
            >
              Continue as guest
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default OfflinePaymentCancel;
